import { render } from "./dlt-number.vue?vue&type=template&id=518f8c0d&scoped=true"
import script from "./dlt-number.vue?vue&type=script&lang=js"
export * from "./dlt-number.vue?vue&type=script&lang=js"

import "./dlt-number.vue?vue&type=style&index=0&id=518f8c0d&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518f8c0d"]])

export default __exports__